import { ReactNode } from 'react';
import HamburgerIcon from '../assets/icons/hamburger.svg?react';
import { useHeader } from '../contexts/HeaderContext';
import { useMobileSidebar } from '../contexts/MobileSidebarContext';
import { useResponsive } from '../hooks/useResponsive';
import { cn } from '../utils/className';
import { AccountButton } from './AccountButton';
import { IconButton } from './IconButton';

// Register the app switcher web component
import '@tomra/tf-app-switcher';

interface HeaderProps {
  mobileActionButton?: ReactNode;
}

export function Header({ mobileActionButton }: HeaderProps) {
  const { toggle } = useMobileSidebar();
  const { mobileActionButton: contextButton } = useHeader();
  const { prefersMobileLayout } = useResponsive();

  // Use prop if provided, otherwise use context
  const actionButton = mobileActionButton ?? contextButton;

  return (
    <header
      className={cn(
        `border-border-primary flex shrink-0 items-center justify-between
        border-b py-4 pr-2 pl-2`,
        prefersMobileLayout
          ? 'h-(--spacing-header-height-mobile) bg-brand-primary'
          : 'h-header-height bg-surface-primary px-6'
      )}
    >
      {prefersMobileLayout ? (
        <>
          <IconButton
            className='hover:bg-transparent'
            aria-label='Toggle menu'
            icon={
              <HamburgerIcon
                width={24}
                height={24}
                className='fill-white [&_path]:fill-white'
              />
            }
            onClick={toggle}
          />
          <img src='/logo-mobile-header.svg' alt='Tomra Logo' className='h-4' />
        </>
      ) : (
        <div className='flex items-center gap-2'>
          <tf-app-switcher current-app='pulse' position='left' theme='light' />
          <div className='flex items-end gap-2'>
            <img src='/tomra-logo-text.svg' alt='Tomra Logo' className='h-3.5' />
            <img src='/logo-pulse.svg' alt='Pulse Logo' className='h-2.5' />
          </div>
        </div>
      )}
      <div className='flex items-center gap-2'>
        {prefersMobileLayout ? (
          actionButton && <div className='text-surface-primary'>{actionButton}</div>
        ) : (
          <AccountButton className='flex'></AccountButton>
        )}
      </div>
    </header>
  );
}
